import { useState, useEffect } from "react";

export default function Affichage() {
  const [darkMode, setDarkMode] = useState(false);
  const [fontSize, setFontSize] = useState("md");
  const [density, setDensity] = useState("normal");

  // Applique les paramètres d'affichage au chargement
  useEffect(() => {
    document.documentElement.classList.toggle("dark", darkMode);
    document.documentElement.style.fontSize = fontSize === "lg" ? "18px" : fontSize === "sm" ? "14px" : "16px";
  }, [darkMode, fontSize]);

  return (
    <div className="p-6">
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Paramètres d'affichage</h3>

      {/* Mode sombre */}
      <div className="mt-4 flex items-center justify-between">
        <span className="text-gray-700 dark:text-gray-300">Mode sombre</span>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={darkMode}
            onChange={() => setDarkMode(!darkMode)}
            className="sr-only peer"
          />
          <div className="w-11 h-6 bg-gray-300 peer-focus:ring-2 peer-focus:ring-indigo-500 rounded-full peer-checked:bg-indigo-600 peer-checked:after:translate-x-full after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
        </label>
      </div>

      {/* Taille de la police */}
      <div className="mt-4">
        <label className="text-gray-700 dark:text-gray-300">Taille de la police</label>
        <select
          value={fontSize}
          onChange={(e) => setFontSize(e.target.value)}
          className="w-full mt-2 p-2 border rounded-lg bg-white dark:bg-gray-700 dark:text-white"
        >
          <option value="sm">Petite</option>
          <option value="md">Moyenne</option>
          <option value="lg">Grande</option>
        </select>
      </div>

      {/* Densité d'affichage */}
      <div className="mt-4">
        <label className="text-gray-700 dark:text-gray-300">Densité d'affichage</label>
        <select
          value={density}
          onChange={(e) => setDensity(e.target.value)}
          className="w-full mt-2 p-2 border rounded-lg bg-white dark:bg-gray-700 dark:text-white"
        >
          <option value="compact">Compact</option>
          <option value="normal">Normal</option>
          <option value="spacious">Spacieux</option>
        </select>
      </div>
    </div>
  );
}
